import isEmpty from 'lodash-es/isEmpty';
import { useTranslation } from 'react-i18next';

import { Chip } from '@/components/atoms/Chip/Chip';
import { TagAction } from '@/shared/types/action';

interface TagProps {
  action: TagAction;
}
const Tag = ({ action }: TagProps) => {
  const { t } = useTranslation();
  const { tags = [], operation = 'add' } = action;

  return (
    <>
      <p>{t(`dialog.tags.${operation}_tags`)}</p>

      {operation !== 'clear' && (
        <>
          {tags.map((tag) => (
            <Chip key={tag} size="xs" className="my-1 mr-1">
              {tag}
            </Chip>
          ))}

          {isEmpty(tags) && <p>{t('dialog.no_tags')}</p>}
        </>
      )}
    </>
  );
};

export default Tag;
